import { Badge } from '@rdss/client'
import { Component, Prop, h, Host } from '@stencil/core'

/**
 * The component representing the default one lined red Weinfreunde badge.
 * You can also use an object to render multilined badges and style them
 * with the used scss variables.
 *
 * @example
 *
 * Object
 * <wf-badge label="Badge" />
 *
 * <wf-badge label={{ type: 'two-lines', lines: ['LINE 1', 'LINE 2'] }} />
 */
@Component({
    tag: 'wf-badge',
    styleUrl: 'wf-badge.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfBadge {
    /**
     * The type of the badge.
     */
    @Prop({ mutable: true }) type?: string = 'default'

    /**
     * The label displays in the badge.
     */
    @Prop() label? : Badge

    /**
     * Lifecycle hook.
     */
    componentWillRender() {
        this.type = this.label?.type ?? 'default'
    }

    /**
     * @inheritdoc
     */
    render() {
        return (
            <Host>
                <div
                    class='wf-badge'>
                    {this.type === 'two-lines-icon' &&
                        <vx-icon class="vx-icon" icon="add" customClass="reinvert" />
                    }
                    <div class="wf-label">
                        {this.getLabel()}
                    </div>
                </div>
            </Host>
        )
    }

    /**
     * Renders the label of the badge depending on the type of the corresponding prop.
     */
    private getLabel() {
        if(typeof this.label === 'string') {
            return this.label
        }
        return this.label?.lines.map((line, key) => (
            <span class={`wf-label-line wf-label-line-${key + 1}`}>
                {line}
            </span>
        ))
    }
}
